var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"show-tag-filter":true,"show-tag-columns":true,"group-actions":_vm.groupActions,"single-actions":_vm.singleActions,"export-data-options":_vm.exportDataOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }